import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Subsistema } from '../../../catalogos-proces/models/subsistema';
import { SubsistemaService } from '../../../catalogos-proces/services/subsistema.service';
import { Subject } from 'rxjs';
import { AlertService } from '../../../../services/alert.service';
import { ModalService } from 'src/app/services/modal.service';
import { IpPublicService } from 'src/app/services/ip-public.service';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';
import { DataTableDirective } from 'angular-datatables';
import { AmbienteService } from './../../../catalogos-admin/services/ambiente.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';

@Component({
  selector: 'app-subsistema',
  templateUrl: './subsistema.component.html',
  styleUrls: ['./subsistema.component.css']
})
export class SubsistemaComponent implements OnInit, OnDestroy {
  breadCrumbItems = [{ label: 'Administración Sistema' }, { label: 'Catálogos Sistemas' }, { label: 'Subsistemas', active: true }];
  subsistemas: any[] = [];
  submitted = false;
  currentUser!: any;
  ipAddress!: string;
  idSprUsuario: any;
  nameModal: string = 'modalEdit';
  idSprRegisterDelete: number = 0;
  estados: any[] = [];
  nameApp = 'SUBSISTEMAS';
  private buffer!: any;
  public idSprNivel: number = 0;
  selectItems: any[] = [];
  formSubsistema!: UntypedFormGroup;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  isDtInitialized: boolean = false;
  readonly constant = ConstantsCatalogosIdService;
  constructor(
    private fb: FormBuilder,
    private subsistemaService: SubsistemaService,
    private alertService: AlertService,
    public modal: ModalService,
    private ip: IpPublicService,
    private ambienteService: AmbienteService,
    private store: Store<AppState>,
  ) {
    this.buffer = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.buffer);
    this.selectItems = [
      { value: 0, label: 'Seleccione' },
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ]
  }

  get subSistForm() {
    return this.formSubsistema.controls;
  }

  setDataTable():void{
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      }
    };
  }


  setForm(){
    this.formSubsistema = this.fb.group({
      idSprSubsistema: [],
      nombre: ['', [Validators.required]],
      descripcion: [''],
      ponderacion: ['', [Validators.required]],
      aportaValor: ['', [Validators.required]],
      estado: ['', [Validators.required]],
    });
    this.formSubsistema.patchValue({
      estado: this.selectItems[0].value
    });
  }

  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  ngOnDestroy(): void {
    // Destrulle la instancia de DataTable antes de salir del componente
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
      });
    }
  } 
  
  reDrawDataTable(): boolean {
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
    return true;
  }

  initApp() {
    this.getDataSubsistemas();
    this.setDataTable();
    this.setForm();
  }

  ngOnInit(): void {
    this.store.select('globalApp').subscribe((response) => {
      this.idSprNivel =  response.ambienteSeleccionado.nivel.idSprNivel;
    });
    this.getIpPublic();
    this.initApp();
  }
  getDataSubsistemas():void{
    this.subsistemaService.list().subscribe(resp => {
      this.subsistemas = resp;
      this.reDrawDataTable();
    });
  }

  onSubmit() {
    this.submitted = true;
    this.formSubsistema.value.nombre = this.formSubsistema.value.nombre.toUpperCase();
    this.formSubsistema.value.ip = this.ipAddress;
    this.formSubsistema.value.usuario = this.currentUser.idSprUsuario;
    if (!this.formSubsistema.invalid) {
      if (this.formSubsistema.value.idSprSubsistema == null || this.formSubsistema.value.idSprSubsistema == " ") {
        //INICIO
        if (this.listSubsistemExisteDiferente(this.formSubsistema.value.nombre, this.formSubsistema.value.idSprSubsistema)) {
        this.subsistemaService.create(this.formSubsistema.value).subscribe(dataInsert => {
          this.initApp();
          this.alertService.createOk();
          this.modal.close();
        }), error => ({

        })
        }//FIN
      } else {
        //INIICIO
        if (this.listSubsistemExisteDiferente(this.formSubsistema.value.nombre, this.formSubsistema.value.idSprSubsistema)) {
        this.subsistemaService.update(this.formSubsistema.value).subscribe(dataUpdate => {
          this.initApp();
          this.alertService.updateOk();
          this.modal.close();
        }), error => ({
        })
      } //FIN
      }

    } else {
      this.alertService.warning("¡Atención!", "Formulario invalido.");
    }
  }

/////////////NO PERMITE CREAR SUBSISTEMASCON EL MISMO NOMBRE//////////

  listSubsistemExisteDiferente(nombre: any, idSprSubsistema: any) {
    let vector: any = [];
    let vectorFiltrado: any = [];
    let nombresInicio = nombre.trimStart();
    let nombresFin = nombresInicio.trimEnd();
    vector = this.subsistemas;
    //vectorFiltrado = vector.filter((elemento) => elemento != idSprSubsistema)
    for (let elemento of vector) {
      if (elemento.idSprSubsistema !== idSprSubsistema) {
        vectorFiltrado.push(elemento);
        //return false;
      }
    }

    for (let elemento of vectorFiltrado) {
      if (elemento.nombre == nombresFin) {
        this.alertService.warning('¡Atención!',"Existe un subsistema con el mismo nombre.");
        return false;
      }
    }
    return true;
  }

  edit(obj: Subsistema) {
    this.openModalNew();
    this.formSubsistema.patchValue({
      idSprSubsistema: obj.idSprSubsistema,
      descripcion: obj.descripcion,
      ponderacion: obj.ponderacion,
      aportaValor: obj.aportaValor,
      nombre: obj.nombre,
      estado: obj.estado
    });
  }

  openModalNew() {
    this.onResetForm();
    this.modal.open(this.nameModal);
  }


  onResetForm() {
    this.submitted = false;
    this.formSubsistema.reset();
  }

  delete(id: number) {
    this.idSprRegisterDelete = id;
    this.modal.open('del');
  }

  verifyAmbiente(){
    return this.ambienteService.list(`?idSprSubsistema=${this.idSprRegisterDelete}&delLog=N`).toPromise();
  }

  async confirmDelete() {

    let confirmDelete = true;
    let dataVerifyRelacion: any = [];
  ///////verificacion1 si existe datos relacionado
    dataVerifyRelacion =  await this.verifyAmbiente();
   (dataVerifyRelacion.length > 0 ) ? confirmDelete = false : "";

    if (confirmDelete) {
      this.ambienteService.list(`?idSprSubsistema=${this.idSprRegisterDelete}&delLog=N`)
        .subscribe(response => {

          if (response.length < 1) {
            this.subsistemaService.update({
              "idSprSubsistema": this.idSprRegisterDelete,
              "usuario": this.currentUser.idSprUsuario,
              "delLog": "S",
              "ip": this.ipAddress
            }).subscribe(resp => {
              this.initApp();
              this.alertService.deleteOk();
              this.modal.close();
            }, (err) => {
              this.alertService.deleteError();
              this.modal.close();
            });
          } else {
            this.alertService.EliminarRegistro();
            this.modal.close();
          }
        });
    } else {
      this.alertService.EliminarRegistro();
      this.modal.close();
    }
  }

  closeModal(){
    this.modal.close();
  }


}
